import React, { FC, useEffect, useState } from "react";

import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { Card, Col, Row } from "antd";
import memberDetailsService from "@services/memberDetails.service";
import Recommendation from "../actionable-insights/recommendations";
import UnderCodingMedication from "../actionable-insights/under-coding-medication";
import Ethnicity from "../social-determinants/ethnicity";
import OccupationalFinancial from "../social-determinants/occupational-financial";
import HousingAndNutrition from "../social-determinants/housing-and-nutrition";
import HealthMeasure from "../risk-score/health-measures";
import CurrentHealthStats from "../overview/current-health-stats";
import KeyNumbers from "../overview/key-numbers";
import GapMedication from "../actionable-insights/gaps-medication";
// import RegularGap from "../actionable-insights/regular-gaps";
import HedisGaps from "../actionable-insights/hedis-gaps";
import UtilizationMeasures from "../risk-score/utilization-measures";
import DiseasBasedRisk from "../risk-score/diseas-based-risk";
import Intellectual from "../social-determinants/intellectual";
import membersService from "@services/members.service";
// import { useNavigate } from "react-router-dom";
// import { routeMap } from "@utils/constants";
import WeatherReport from "../contact-details/map-weather-report";
import GeneralDetail from "../contact-details/general-address";
import PcpClinicInformations from "../contact-details/pcp-clinic-information";
import KinsDetails from "../contact-details/kins-details";
import StarGap from "../actionable-insights/star-gaps";
import EndOfLife from "../overview/end-of-life";
import { isEmpty } from "lodash";
import AlternativeGenericMedication from "../actionable-insights/alternative-generic-medication/alternative-generic-medication";
import Icon from "@assets/icon_config";

import "./my-dashboard.scss";
import PatientProfileMatrix from "../overview/patient-profile-matrix";
import MemberDetails from "../overview/memberDetails/memberDetails";
import Vitals from "../overview/vitals";
import Labs from "../overview/labs";
import { getClientName } from "@utils/helpers";
//import { forkJoin } from "rxjs";

import { usePatientProfileStore } from "@stores/patientProfileStore";
import Measures from "../care-gaps/measures";
import CoordinatorDetails from "../contact-details/coordinator-details";


const MyDashboard: FC<any> = (props) => {
  const [dashboardData, setDashboardData] = useState<any>({});
  const [dashBoardCardLoader, setDashBoardCardLoader] = useState<any>(false);
  const [activeKey, setActiveKey] = useState<any[]>(["1"]);
  const [activePanels, setActivePanels] = useState<any>(props.pinCardIds ? props.pinCardIds : []);

  const [patientId, setPatientId] = useState<any>(null);
  const clientName = getClientName()
  // const navigate = useNavigate();

  const setMemberDetailsAttributedPcpNameLetest = usePatientProfileStore((state) => state.setMemberDetailsAttributedPcpNameLetest);
  const setMemberDetailsAttributedOfficeNameLetest = usePatientProfileStore((state) => state.setMemberDetailsAttributedOfficeNameLetest);

  const _pId = membersService?.getCurrentMember?.patient_id;

  const getDashboardRecords = (id: number) => {
    props.setMainLoader(true);
    setDashBoardCardLoader(true);
  memberDetailsService.getMyDashboardRecords(id).subscribe({
    next: (myDaashboardData) => {
      props.setMainLoader(false);
      let md = myDaashboardData?.data?.data
      setDashboardData(md);
      if (myDaashboardData?.data?.data?.Overview?.memberDetails?.attributed_pcp_name) {
        setMemberDetailsAttributedPcpNameLetest(myDaashboardData?.data?.data?.Overview?.memberDetails?.attributed_pcp_name);
        setMemberDetailsAttributedOfficeNameLetest(myDaashboardData?.data?.data?.Overview?.memberDetails?.attributed_office_name);
      }
      let total = 0
      let countMap = {}
      Object.entries({...md}).forEach(([key, val]:[any, any])=>{
        let len = Object.keys(val).length
        total += len
        Object.assign(countMap, {[key]: len})
      })
      Object.assign(countMap, {"MyDashboard":total});
      props.countMapChangeHandler(countMap);
      setDashBoardCardLoader(false);
      setActivePanels(props.pinCardIds ? props.pinCardIds : [])
    },
    error: (e) => {
      props.setMainLoader(false);
      setDashboardData({});
      setDashBoardCardLoader(false);
      setActivePanels(props.pinCardIds ? props.pinCardIds : [])
    },
  });
};

  useEffect(() => {
    console.log("MyDashboard.useEffect1");
    if ( !isEmpty(patientId)) {
      setActivePanels([]);
      getDashboardRecords(patientId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId]);

  useEffect(() => {
    console.log("MyDashboard.useEffect2");
    if (patientId !== _pId) {
      setPatientId(_pId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_pId])

  useEffect(() => {
    console.log("MyDashboard.useEffect3");
    if ([true, false].includes(props.isPinningHappen)) {
      getRecords(_pId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isPinningHappen]);

  // const getDashboardData = (loaderFlag: boolean) =>{
  //   console.log("MyDashboard.getDashboardData");
  //   const cMember = membersService?.getCurrentMember;
  //   if(cMember && cMember?.patient_id)
  //   {
  //     let pId = parseInt(cMember?.patient_id);
  //     if(loaderFlag)
  //       getDashboardRecords(pId);
  //     else
  //       getRecords(pId);
  //   }
  //   else 
  //     navigate(routeMap["members"])
  // }

  const getRecords = (id: number) => {
    memberDetailsService.getMyDashboardRecords(id).subscribe({
      next: (myDaashboardData) => {
        let md = myDaashboardData?.data?.data
        setDashboardData(md);
      },
      error: (e) => {
        setDashboardData({});
      },
    });
  };

  /*const changeHandler = (oKey: any, iKey: any) => {
    const copy = { ...dashboardData };
    if (copy?.[oKey]?.[iKey]) {
      delete copy[oKey][iKey];
    }
    setDashboardData(copy);
  };*/

  const changeCollapse = () => {
    if(activeKey.length > 0 ) {
      setActiveKey([]);
      setActivePanels([]);
    }
    else {
      setActiveKey(["1"])
      setActivePanels(props.pinCardIds ? props.pinCardIds : [])
    }
  }

  useEffect(() => {
    console.log("MyDashboard.useEffect4");
    appInsights.trackPageView({name:"My Dashboard"});
  },[]);

  return (
    <>
      <div className={`dashBoard-header`}>
        <span>You can choose upto 8 widgets</span>
        {Object.entries(dashboardData).length > 0 ? (
          <div className="dashBoard-header__collapse-all-button" onClick={changeCollapse}>
            {activeKey?.length > 0 ? "Collapse All" : "Expand All"}{" "}
            <span className={`dashBoard-header__collapse-all-button__arrow ${activeKey?.length > 0 ? "" : "arrow-down"}`}>
              <Icon name={`${activeKey?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
            </span>
          </div>
        ) : null}
      </div>
      <div>
        {dashboardData?.ActionableInsights?.underCodingMedication && (
          <Row>
            <Col span={24}>
              <Card>
                <UnderCodingMedication
                  data={dashboardData?.ActionableInsights?.underCodingMedication}
                  pinCardIds={props.pinCardIds}
                  pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ActionableInsights")}
                  activeKey={activeKey}
                />
              </Card>
            </Col>
          </Row>
        )}

        {dashboardData?.ActionableInsights?.gapsInMedication && (
          <Row>
            <Col span={24}>
              <Card>
                <GapMedication
                  data={dashboardData?.ActionableInsights?.gapsInMedication}
                  pinCardIds={props.pinCardIds}
                  pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ActionableInsights")}
                  activeKey={activeKey}
                />
              </Card>
            </Col>
          </Row>
        )}

        {dashboardData?.ActionableInsights?.regularGaps && (
          <Row>
            <Col span={24}>
              <StarGap
                data={dashboardData?.ActionableInsights?.regularGaps}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ActionableInsights")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.ActionableInsights?.recommendations && (
          <Row style={{ marginBottom: "10px" }}>
            <Col span={24}>
              <Recommendation
                data={dashboardData?.ActionableInsights?.recommendations}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ActionableInsights")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {/* {dashboardData?.ActionableInsights?.regularGaps && (
          <Row style={{ margin: "10px 0px" }}>
            <Col span={24}>
              <Card>
                <RegularGap
                  data={dashboardData?.ActionableInsights?.regularGaps}
                  pinCardIds={props.pinCardIds}
                  pinChangeHandler={(id:any, isAdd: boolean)=>props.pinChangeHandler(id, isAdd, "ActionableInsights")}
                  activeKey={activeKey}
                />
              </Card>
            </Col>
          </Row>
        )} */}

        {dashboardData?.ActionableInsights?.hedisGap && (
          <Row>
            <Col span={24}>
              <Card>
                <HedisGaps
                  data={dashboardData?.ActionableInsights?.hedisGap}
                  pinCardIds={props.pinCardIds}
                  pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ActionableInsights")}
                  activeKey={activeKey}
                />
              </Card>
            </Col>
          </Row>
        )}

        {dashboardData?.ActionableInsights?.alternateMedication && (
          <Row>
            <Col span={24}>
              <AlternativeGenericMedication
                data={dashboardData?.ActionableInsights?.alternateMedication?.values}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ActionableInsights")}
                setActiveTabKey={props.setActiveTabKey}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                alternativegenericmedicationDataPinCardID={dashboardData?.ActionableInsights?.alternateMedication?.datacardId}
              />
            </Col>
          </Row>
        )}
        {dashboardData?.Overview?.profileMatrixCardId && (
          <Row>
            <Col span={24}>
              <PatientProfileMatrix
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "Overview")}
                pinCardIds={props.pinCardIds}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}
        {dashboardData?.Overview?.keyNumbersCardId && (
          <Row>
            <Col span={24}>
              <KeyNumbers
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "Overview")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.Overview?.memberDetailsCardId && (
          <Row>
            <Col span={24}>
              <MemberDetails
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "Overview")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.Overview?.eolCardId && (
          <Row>
            <Col span={24}>
              <EndOfLife
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "Overview")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {/* 
        {dashboardData?.Overview?.currentHealthStats && (
          <Row>
            <Col span={24}>
              <CurrentHealthStats
                data={dashboardData?.Overview}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id:any, isAdd: boolean)=>props.pinChangeHandler(id, isAdd, "Overview")}
                activeKey={activeKey}
              />
            </Col>
          </Row>
        )}
           */}

        {dashboardData?.EHRData?.vitalStatsDatacardId && process.env.REACT_APP_SHOW_LABS_VITALS === "true" && (
          <Row>
            <Col span={24}>
              <Vitals
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "EHRData")}
                pinCardIds={props.pinCardIds}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.EHRData?.labDetailsDatacardId && process.env.REACT_APP_SHOW_LABS_VITALS === "true" && (
          <Row>
            <Col span={24}>
              <Labs
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "EHRData")}
                pinCardIds={props.pinCardIds}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.Overview?.currentHealthStats && (
          <Row>
            <Col span={24}>
              {/* <Card> */}
              <CurrentHealthStats
                data={dashboardData?.Overview}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "Overview")}
                activeKey={activeKey}
              />
              {/* </Card> */}
            </Col>
          </Row>
        )}
      </div>

      <div>
        {dashboardData?.RiskScore?.healthMeasures && (
          <Row>
            <Col span={24}>
              <HealthMeasure
                data={dashboardData?.RiskScore?.healthMeasures}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "RiskScore")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.RiskScore?.utilizationMeasures && (
          <Row>
            <Col span={24}>
              <UtilizationMeasures
                data={dashboardData?.RiskScore?.utilizationMeasures}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "RiskScore")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.RiskScore?.diseaseBasedRisk && clientName !== "Millennium" && (
          <Row>
            <Col span={24}>
              <DiseasBasedRisk
                data={dashboardData?.RiskScore?.diseaseBasedRisk}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "RiskScore")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.SocialDeterminants?.intellectual && (
          <Row>
            <Col span={24}>
              <Intellectual
                data={dashboardData?.SocialDeterminants?.intellectual}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "SocialDeterminants")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                loading={dashBoardCardLoader}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.SocialDeterminants?.ethnicity && (
          <Row>
            <Col span={24}>
              <Ethnicity
                data={dashboardData?.SocialDeterminants?.ethnicity}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "SocialDeterminants")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                loading={dashBoardCardLoader}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.SocialDeterminants?.occupationalAndFinancial && (
          <Row>
            <Col span={24}>
              <OccupationalFinancial
                data={dashboardData?.SocialDeterminants?.occupationalAndFinancial}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "SocialDeterminants")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                loading={dashBoardCardLoader}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.SocialDeterminants?.housingAndNutrition && (
          <Row>
            <Col span={24}>
              <HousingAndNutrition
                data={dashboardData?.SocialDeterminants?.housingAndNutrition}
                pinCardIds={props.pinCardIds}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "SocialDeterminants")}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                loading={dashBoardCardLoader}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.ContactDetails?.generalAndAddress && (
          <Row>
            <Col span={24}>
              <GeneralDetail
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                dataCardId={dashboardData?.ContactDetails?.generalAndAddress?.datacardId}
                data={dashboardData?.ContactDetails?.generalAndAddress}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ContactDetails")}
                pinCardIds={props.pinCardIds}
                loading={dashBoardCardLoader}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.ContactDetails?.datacardIdForWeatherNearBy && (
          <Row>
            <Col span={24}>
              <WeatherReport
                activeTabKey={props.activeTabKey}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                dataCardId={dashboardData?.ContactDetails?.datacardIdForWeatherNearBy}
                data={dashboardData?.ContactDetails?.generalAndAddress}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ContactDetails")}
                pinCardIds={props.pinCardIds}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.ContactDetails?.pcpAndClinicInformation && (
          <Row>
            <Col span={24}>
              <PcpClinicInformations
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                dataCardId={dashboardData?.ContactDetails?.pcpAndClinicInformation?.datacardId}
                data={dashboardData?.ContactDetails?.pcpAndClinicInformation}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ContactDetails")}
                pinCardIds={props.pinCardIds}
                loading={dashBoardCardLoader}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.ContactDetails?.nextOfKinsInformation && (
          <Row>
            <Col span={24}>
              <KinsDetails
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                dataCardId={dashboardData?.ContactDetails?.nextOfKinsInformation?.datacardId}
                data={dashboardData?.ContactDetails?.nextOfKinsInformation}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ContactDetails")}
                pinCardIds={props.pinCardIds}
                loading={dashBoardCardLoader}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.CareGaps?.measuresDataCardId && (
          <Row>
            <Col span={24}>
              <Measures
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "CareGaps")}
                pinCardIds={props.pinCardIds}
                activeKey={activePanels}
                setActivePanels={setActivePanels}
              />
            </Col>
          </Row>
        )}

        {dashboardData?.ContactDetails?.contactDetailsForCoordinator && (
          <Row>
            <Col span={24}>
              <CoordinatorDetails
                activeKey={activePanels}
                setActivePanels={setActivePanels}
                data={dashboardData?.ContactDetails?.contactDetailsForCoordinator}
                pinChangeHandler={(id: any, isAdd: boolean) => props.pinChangeHandler(id, isAdd, "ContactDetails")}
                pinCardIds={props.pinCardIds}
              />
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

export default withAITracking(reactPlugin, MyDashboard);
